import { vnApp } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app";

export class vnApp_pubinsights extends vnApp {

	public static readonly ROLE_NAME_ADMINISTRATOR = 1;
	public static readonly ROLE_PRODUCT_MANAGER = 13;
	public static readonly ROLE_GENERAL_MANAGER = 17;

	public getIsLoggedInHttpCallUrl(){

		return '/api/access/isLoggedIn/';
	}

	public isOfRole(role: Number) {
		let show = false;

		let vnApp = this;
		let roles: Array<any> = vnApp.loggedUser.user.vnAppUser.roles;
		let roleIds = [];

		for (let role of roles) {
			roleIds.push(role.id);
		}
		if (roleIds.indexOf(role) > -1) {
			show = true;
		}

		return show;
	}

}



// WEBPACK FOOTER //
// ./js/components/vnApp_pubinsights.ts